"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaFormat = void 0;
var SchemaFormat;
(function (SchemaFormat) {
    SchemaFormat["Apps"] = "integratedApps";
    SchemaFormat["Boolean"] = "boolean";
    SchemaFormat["Checkmark"] = "checkmark";
    SchemaFormat["Code"] = "code";
    SchemaFormat["Date"] = "date";
    SchemaFormat["DateTime"] = "datetime";
    SchemaFormat["Definition"] = "definition";
    SchemaFormat["Description"] = "description";
    SchemaFormat["Enum"] = "enum";
    SchemaFormat["HelpText"] = "helptext";
    SchemaFormat["Notes"] = "notes";
    SchemaFormat["Object"] = "object";
    SchemaFormat["Owner"] = "owner";
    SchemaFormat["SalesforceUser"] = "salesforceUser";
    SchemaFormat["Stakeholder"] = "stakeholder";
    SchemaFormat["None"] = "none";
    SchemaFormat["PageLayouts"] = "pageLayoutFilter";
    SchemaFormat["PopulationPercentage"] = "populationPercentage";
    SchemaFormat["Primary"] = "primary";
    SchemaFormat["PrimaryInternal"] = "primaryInternal";
    SchemaFormat["Profiles"] = "profileFilter";
    SchemaFormat["ReferenceCount"] = "referenceCount";
    SchemaFormat["Tags"] = "tags";
    SchemaFormat["Text"] = "text";
    SchemaFormat["Time"] = "time";
})(SchemaFormat || (exports.SchemaFormat = SchemaFormat = {}));
//# sourceMappingURL=SchemaFormat.js.map